import React from "react";

import { IViewProps, View } from "core/decorators/View";
import styled from "styled-components";
import MenuViewConfig from "./MenuViewConfig";

/**
 * @overview: Displays a horizontal or vertical menu
 * @author: jesposito
 */

@View({id: "menu", configClass: MenuViewConfig})
export default class MenuView extends React.PureComponent<IViewProps<MenuViewConfig>> {

	public render() {
		const { config, children } = this.props;

		const Cont = styled.div`
			display: flex;
			flex-direction: ${config.vertical ? "column" : "row"};
			background-color: ${config.backgroundColor};
			background-image: ${config.backgroundImage};
			padding: ${config.padding};
		`;

		return (
			<Cont>
				{children}
			</Cont>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/menu/Menu.view.tsx